import { registerEvent } from "web/redux/ducks/event-count-tracker";
import store from "web/redux/store";
import environment from "web/script/modules/environment";
import browser from "web/script/utils/browser";
import sessionTimer from "web/script/utils/session-timer";
import storage from "web/script/utils/storage";

const EVENT_COUNTER_CATEGORIES = [
    "feed",
    "navigation",
    "product area",
    "product_card",
    "feeds_show_more",
    "sort_by",
    "filter",
];

export default {
    send(data) {
        const blockVariant = environment.getFeature("mg_block_on_event_counter");

        data.forEach((event) => {
            if (
                environment.getFeature("mg_show_timed_app_download_block") &&
                EVENT_COUNTER_CATEGORIES.includes(event.data.category)
            ) {
                /*
                 * Update the session storage to track if the user is:
                 * mid redirect or has made a valid interaction.
                 * These are controlled here.
                 * Interactions start the timer sessionTimer.onChange()
                 *  isLoadingNextPage: true means that the next page is loading so we shouldnt block
                 * block will instead happen on load
                 */
                const appBlockShown = storage.get("appBlockShown", null, true)
                    ? storage.get("appBlockShown", null, true)
                    : { hasBeenBlocked: false, hasInteraction: false, isLoadingNextPage: false };
                if (!appBlockShown.hasBeenBlocked) {
                    const redirectClick = event.data.category === "product_card";
                    storage.set(
                        "appBlockShown",
                        {
                            hasBeenBlocked: false,
                            hasInteraction: true,
                            isLoadingNextPage: redirectClick,
                        },
                        true
                    );
                    sessionTimer.onChange();
                }
            }
            if (
                event.type !== "event" ||
                !browser.ios ||
                (event.data.page_type !== "feed" && event.data.page_type !== "search")
            ) {
                return Promise.resolve();
            }
            if (
                EVENT_COUNTER_CATEGORIES.includes(event.data.category) &&
                (blockVariant === "hard_block" || blockVariant === "soft_block")
            ) {
                // for filter count the event on "filter open" only
                // otherwise for any action in the EVENT_COUNTER_CATEGORIES
                if (
                    event.data.category !== "filter" ||
                    (event.data.category === "filter" && event.data.action === "open")
                ) {
                    store.dispatch(
                        registerEvent({ category: event.data.category, action: event.data.action })
                    );
                }
            } else if (
                event.data.category === "app_overlay" &&
                event.data.action === "modal_dismissed" &&
                event.data.label === "event_counter_block"
            ) {
                // listening to the dismissal of the modal for soft_block
                store.dispatch(
                    registerEvent({ category: event.data.category, action: event.data.action })
                );
            }
        });
        // no way of waiting for this to be done
        return Promise.resolve();
    },
};
